<div class="dialog-title mat-tab-label-active text-muted font-family px-3">
  <div>{{"settings"|translate}}</div>

  <div>
    <button cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle mat-icon-button class="drag-handler text-center" style="cursor: grab;">
      <mat-icon style="font-size: 18px;">open_with</mat-icon>
    </button>
    <button mat-icon-button class="text-center" mat-dialog-close>
      <mat-icon style="font-size: 18px;">close</mat-icon>
    </button>
  </div>
</div>

<div id="dark" class="noprint setting-bg" style="height: 473px;">
  <div class="row settings">
    <div class="mx-auto col-md-10 m-3">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 d-flex justify-content-center">
            <div>
              <h4 class=" profile-heading text-color-theme"><i class="fas fa-palette m-2"></i>{{"apperance"|translate}}</h4>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 d-flex justify-content-center">
            <div>
              <h4 class=" profile-heading text-color-theme"><i class="fas fa-shield-alt m-2"></i>{{"security"|translate}}</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row settings-notification align-items-center mt-4">
        <div class="col-md-6 text-color-theme vl px-5 ">
          <div class="mb-3 d-flex justify-content-between">
            <div>
              <h6 class=" profile-heading text-color-theme">{{"night-mode"|translate}}</h6>
            </div>
            <div>
              <mat-slide-toggle
                color="primary"
                [(ngModel)]="darkTheme"
                (change)="switchTheme()"
              ></mat-slide-toggle>
            </div>
          </div>
          <div class="mb-3 d-flex justify-content-between">
            <div>
              <h6 class="profile-heading text-color-theme">{{"pricesBar"|translate}}</h6>
            </div>
            <div>
              <mat-slide-toggle color="primary" [(ngModel)]="showNewsBar"></mat-slide-toggle>
            </div>
          </div>
          <div class="mb-3 d-flex justify-content-between">
            <div>
              <h6 class="profile-heading text-color-theme">{{"quick-btn"|translate}}</h6>
            </div>
            <div>
              <mat-slide-toggle color="primary" [(ngModel)]="showQuickButton"></mat-slide-toggle>
            </div>
          </div>
          <div class="mb-3 d-flex align-items-center justify-content-between">
            <div>
              <h6 class="profile-heading text-color-theme">
                {{ "fontSize" | translate }}
              </h6>
            </div>
            <div>
              <ng-select
              style="width:fit-content"
              [clearable]="false"
              [searchable]="false"
              class="custom"
              appearance="outline"
              [(ngModel)]="fontSize"
            >
              <ng-option
                class="text-color-theme"
                *ngFor="let size of zoomValues"
                value="{{ size }}"
              >
              <span 
              class="text-color-theme">
              {{size}}%
            </span>
              </ng-option>
            </ng-select>
            </div>
          </div>
        </div>
        <div class="col-md-6 text-color-theme px-5 ">
          <div class="mb-3 d-flex justify-content-center">
            <div class="p-1 mt-3 mx-2 d-flex justify-content-center">
              <a (click)="navigateChangePw()" class="rounded-pill">{{'change-password'| translate}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="p-1 mt-3 mx-2 d-flex justify-content-center">
        <button type="button" class="btn btn-primary" (click)="saveSettings()">{{'save'| translate}}</button>
      </div>
    </div>
  </div>
</div>
